"use client";

import _slicedToArray from "/codebuild/output/src859445700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { usePopoverStoreProps } from "./O2PQ2652.js";
import { useStore, useStoreProps } from "./YV4JVR4I.js";

// src/hovercard/hovercard-store.ts
import * as Core from "@ariakit/core/hovercard/hovercard-store";
function useHovercardStoreProps(store, update, props) {
  useStoreProps(store, props, "timeout");
  useStoreProps(store, props, "showTimeout");
  useStoreProps(store, props, "hideTimeout");
  return usePopoverStoreProps(store, update, props);
}
function useHovercardStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useStore = useStore(Core.createHovercardStore, props),
    _useStore2 = _slicedToArray(_useStore, 2),
    store = _useStore2[0],
    update = _useStore2[1];
  return useHovercardStoreProps(store, update, props);
}
export { useHovercardStoreProps, useHovercardStore };